import * as React from "react";
export var WasmContext = React.createContext({
    decodeWireFormat: function (_) {
        throw new Error("cannot decode wire format");
    },
});
export default WasmContext;
